import React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
// hooks
import { useModalData } from 'hooks/index'
// store
import { setAccumulatedFormData } from 'store/reducers/accumulatedForms'
// components
import Modal from 'components/UI/Modal'
import Header from 'components/UI/Modal/Header'
import SetLicenceForm from './SetLicenceForm'
// constants
import { Forms, Modals } from 'constants/index'
import { LICENCE_TYPES_OPTIONS } from 'constants/licences'
// types
import { RootState } from 'store/store'
// utils
import get from 'lodash/get'

interface Props {
  handleSwitchStrategy: (key: string) => void
}

const SetLicencingModal: React.FC<Props> = ({ handleSwitchStrategy }) => {
  const dispatch = useDispatch()

  const {
    hideModal,
    modalData: { key, name, width, isOpen }
  } = useModalData({ modalType: Modals.SET_LICENCING_MODAL })

  const accountForm = useSelector((state: RootState) => state.accumulatedForms[Forms.ACCUMULATED_CREATE_ACCOUNT])

  const handleHideModal = () => hideModal()

  const handleSubmit = (data) => {
    handleSwitchStrategy(key)

    const licences = get(accountForm, 'licences', {})

    dispatch(
      setAccumulatedFormData({
        type: Forms.ACCUMULATED_CREATE_ACCOUNT,
        data: {
          licences: {
            ...licences,
            [key]: {
              active: true,
              ...get(licences, key, {}),
              ...data
            }
          }
        }
      })
    )

    handleHideModal()
  }

  const getInitialValues = () => {
    let initialValues = {
      licenceType: LICENCE_TYPES_OPTIONS[0]
    }

    const values = get(accountForm, `licences[${key}]`, {})

    if (values) {
      initialValues = {
        ...initialValues,
        ...values
      }
    }

    return initialValues
  }

  return (
    <Modal hideModal={handleHideModal} isOpen={isOpen} width={width}>
      <Header handleClearClick={handleHideModal}>{name} Licences</Header>
      <SetLicenceForm onSubmit={handleSubmit} onCancelClick={handleHideModal} initialValues={getInitialValues()} />
    </Modal>
  )
}

export default SetLicencingModal
